export const INPUT_MAX_LENGTH_INDICATOR_THRESHOLD = 0.9;
export const TEXTAREA_MAX_LENGTH_INDICATOR_THRESHOLD = 0;
